// extracted by mini-css-extract-plugin
export var defaultWrapper = "_is-3";
export var downloadButton = "_is-4";
export var fileContainer = "_is-9 _is-7";
export var fileContainerBase = "_is-7";
export var fileContainerFixedHeight = "_is-8 _is-7";
export var fileInfo = "_is-5";
export var fileInfoWidthRestricted = "_is-6";
export var fileType = "_is-1";
export var fileTypeName = "_is-2";
export var image = "_is-0";
export var link = "_is-b";
export var overflowEllipsis = "_is-a";